exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".dz-progress[data-v-f11bddba] {\n  display: none !important;\n}\n.vue-dropzone[data-v-f11bddba] {\n  border: 1px dashed #E0E0E0;\n  font-family: \"Roboto\", sans-serif;\n}\n.box_valid[data-v-f11bddba] {\n  font-size: 13px;\n  padding: 5px;\n  color: red;\n}\n.btn_enviar_insumos[data-v-f11bddba] {\n  background-color: #FFFFFF !important;\n  border: 1px solid #18A0FB !important;\n  border-radius: 5px;\n  color: #18A0FB !important;\n}\n.btn_enviar_insumos[data-v-f11bddba]:hover {\n  background-color: #18A0FB !important;\n  color: #FFFFFF !important;\n}", ""]);

// exports
